<template>
    <div style="padding-bottom: 40px">
        <CFTitle title="7. Obiective proiect"></CFTitle>
        <validation-observer ref="objectivesObserver">
            <b-form @submit.prevent>
                <div class="obiectiv">
                    <div class="header">
                        <span class="title">
                            <strong>{{ objectives.main && objectives.main.title ? objectives.main.title : '' }}</strong>
                        </span>
                    </div>
                    <div class="sub-item">
                        <p>{{ objectives.main && objectives.main.content ? objectives.main.content : '' }}</p>
                    </div>
                </div>
            </b-form>
        </validation-observer>
        <div v-for="(obiectiv, key) in objectives.secondary" :key="key" class="obiectiv">
            <div class="header">
                <span class="title">
                    <span class="flex align-center" style="width: 90%; white-space: nowrap;">
                        <strong class="flex align-center" style="margin-right: 10px;">
                            <span style="width: 90%;">Obiectiv specific</span>
                            <span style="margin: 0 5px;">{{ obiectiv.number }}</span>
                        </strong>
                        <span style="font-size: 14px;">{{ obiectiv.title ? obiectiv.title : '' }}</span>
                    </span>
                </span>
            </div>
            <div class="sub-item">
                <p >{{ obiectiv.content }}</p>
            </div>
        </div>
        <p class="info-text" style="margin-top: 20px;">Info:  Pentru a modifica aceste informații vă rugăm să vizitați secțiunea: <router-link to="/aplicatii/m3-sketch/obiective">Obiective</router-link></p>
    </div>
</template>

<script>
    import { BForm, BFormTextarea, BIconPencilSquare, BIconTrash, BIconCheckCircleFill, BFormCheckbox, BFormInput, BIconPlusCircleFill} from "bootstrap-vue";

    import CFTitle from "./CFTitle"
    import M3FormTitle from "../M3FormTitle";
    import {ValidationObserver, ValidationProvider} from "vee-validate";


    export default {
        name: "CFObiectiveProiect",
        components: {
            CFTitle,
            BForm,
            BFormTextarea,
            BIconPencilSquare,
            BIconTrash,
            BIconCheckCircleFill,
            BIconPlusCircleFill,
            BFormCheckbox,
            BFormInput,
            M3FormTitle,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            data:{
                type:Object,
                default:null
            }
        },
        data(){
            return {
                objectives:{},
                companyName: null,
            }
        },
        mounted(){
            this.companyName = JSON.parse(localStorage.getItem('currentM3Company')).name;
            this.objectives = this.getObjectives()
            this.$store.dispatch('finantare/addToProgress', 'Obiective proiect');
        },

        methods: {
            getObjectives() {
                return this.data &&this.data.m3_project && this.data.m3_project.objectives && this.data.m3_project.objectives.objectives ? this.data.m3_project.objectives.objectives : {
                    main:
                        {
                            id: 0,
                            main: true,
                            content: 'Obiectivul principal al proiectului reprezintă consolidarea poziției pe piață a companiei '+ this.companyName +' că urmare a efectelor pandemiei COVID-19 și a consecințelor sale la nivelul companiei transpuse prin scăderea cifrei de afaceri cu '+ parseFloat(this.data.turnover_difference).toFixed(2) +'%. Prin implementarea proiectului compania '+ this.companyName +' își va consolida capacitatea de a crește pe piețele regionale, naționale și internaționale și de a se angaja în procese de inovare.',
                            title: 'OBIECTIVUL GENERAL AL PROIECTULUI'
                        }
                    ,
                    secondary: [
                        {
                            id: 1,
                            main: false,
                            content: '(a se edita/personaliza textul) \n' +
                                '\n' +
                                'Realizarea unei investiții noi pentru '+ this.companyName +', care implică achiziția de utilaje și echipamente îmbunătățirea capabilităților tehnologice utilizate în realizarea serviciilor, produselor etc. \n' +
                                '\n' +
                                '(sau) \n' +
                                '\n' +
                                'Consolidarea și dezvoltarea durabilă a sectorului productiv al societății prin dotare cu active necesare pentru desfășurarea de activități în domeniul (domeniu) \n' +
                                '\n' +
                                '(sau) \n' +
                                '\n' +
                                'Realizarea proiectului de investiții prin valorificarea oportunității de accesare finanțare din fonduri europene în cadrul Programului Operațional Competitivitate 2014-2020, Axa Prioritară 4, Acțiunea 4.1.1. \n',
                            title: 'Modifică titlul obiectivului',
                            number: 1
                        },
                        {
                            id: 2,
                            main: false,
                            content: '(a se edita/personaliza textul)\n' +
                                '\n' +
                                'Pregătirea unei redresări verzi, digitale și reziliențe a economiei, prin contribuția cu 76% din valoarea proiectului companiei '+ this.companyName +' la atenuarea schimbărilor climatice și tranziția către o activitate economică care nu cauzează nici un prejudiciu semnificativ obiectivelor de mediu.\n',
                            title: 'Modifică titlul obiectivului',
                            number: 2
                        },
                        {
                            id: 3,
                            main: false,
                            content: '(a se edita/personaliza textul)\n' +
                                '\n' +
                                'Diversificarea producției / serviciilor prin lansarea unui produs/serviciu nou/inovativ (se descrie produsul sau serviciul pe scurt)\n' +
                                '\n' +
                                '* produse noi - inițial dezvoltate și implementate, sau care au suferit modificări majore în tehnologia de producție sau au fost îmbunătățite. Un produs inovator este un produs obținut că urmare a noilor tehnologii (inclusiv fundamental noi) sau în combinație cu cele existente\n' +
                                '\n' +
                                '** Inovarea de produs este acel tip de inovare care este cel mai vizibil pentru consumator și se referă fie la îmbunătățirea unor produse mai vechi din portofoliul companiei, fie la dezvoltarea de noi produse care au la bază noi tehnologii sau care rezolvă noi nevoi ale consumatorilor.\n',
                            title: 'Modifică titlul obiectivului',
                            number: 3
                        },
                        {
                            id: 4,
                            main: false,
                            content: '(a se edita/personaliza textul)\n' +
                                '\n' +
                                'Creșterea productivității muncii în cadrul companiei '+ this.companyName +' în anul 3 de sustenabilitate cu un procent de minim x %, păstrând numărul minim de '+ this.data.employees +' angajați din anul de referință 2019.',
                            title: 'Modifică titlul obiectivului',
                            number: 4
                        },]
                }
            },
        }


    }
</script>

<style scoped>
.header{
  background: #e6cfea !important;
}
.obiectiv .header span{
  color: #515679;
}
.header .title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.header .title svg{
  color: #9da1af;
  cursor: pointer;
}
.header .title svg:not(:last-child){
  margin-right: 10px;
}
.obiectiv .actions svg:first-child{
  margin-right: 10px;
}
.obiectiv{
  margin-top: 30px;
}
.obiectiv .header{
  background: #e9eaec!important;
  padding: 15px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sub-item{
  margin-top: 10px;
  background: #f8f9f9;
  padding: 8px 30px;
  padding-bottom: 60px;
  position: relative;
}
.sub-item svg{
  position: absolute;
  bottom: 10px;
  right: 10px;
  color: #9da1af;
  cursor: pointer;
}
.sub-item svg:hover{
  color: #7f838f;
}
.sub-item .title{
  font-size: 14px;
  color: #515679;
}
.sub-item >>> p{
  word-break: break-all;
}
.sub-item >>> textarea{
  font-size: 12px !important;
  color: #777e90;
  font-weight: 500;
  line-height: 23px;
  background: #e9ecef;
}
</style>
